// Every number the rules of No Thanks! depend on, in one place.
//
// Sourced from the official AMIGO rulebook (©2018 AMIGO Spiel + Freizeit
// GmbH, item 18414 V1-0918), which the TTS mod ships as a Custom_PDF and
// which lives at docs/rulebook.pdf in this repo. Page references below are
// to that document. Nothing here is from memory - earlier drafts of this
// project assumed 3-5 players, which is the OLD edition's range and wrong
// for this rulebook.

// "33 Cards, numbered from 3-35" (p1, Contents).
export const LOWEST_CARD = 3;
export const HIGHEST_CARD = 35;

// "Shuffle the cards thoroughly and put nine cards back into the box
// without looking at them. These cards will not be used." (p1, Set Up 1)
//
// This is the whole engine of the game's tension: nine of the 33 are gone
// and nobody knows which, so a gap in your series might be unfillable and
// you can never be sure. 24 cards are actually played.
export const CARDS_REMOVED = 9;
export const CARDS_IN_PLAY = (HIGHEST_CARD - LOWEST_CARD + 1) - CARDS_REMOVED;

// "3-7 PLAYERS" (p1, header).
export const MIN_PLAYERS = 3;
export const MAX_PLAYERS = 7;

// "Give a supply of counters to each player, based on the number of people
// playing. For 3-5 players, give 11 counters; for 6 players, give 9
// counters; and for 7 players, give 7 counters." (p1, Set Up 3)
//
// Note this is NOT a smooth curve, and the totals are not constant either
// (5 players share all 55; 7 players use only 49). Don't "simplify" it into
// a formula - the rulebook prints three discrete cases and that's the rule.
export const COUNTERS_BY_PLAYER_COUNT = {
  3: 11, 4: 11, 5: 11, 6: 9, 7: 7,
};

export const countersForPlayerCount = (playerCount) => {
  const counters = COUNTERS_BY_PLAYER_COUNT[playerCount];
  if (!counters) {
    throw new Error(`No Thanks! supports ${MIN_PLAYERS}-${MAX_PLAYERS} players, got ${playerCount}`);
  }
  return counters;
};

// "55 Counters" (p1, Contents). Not used as a supply limit by the engine -
// counters only ever move between players and cards, never in or out of the
// game - but asserted in tests as a conservation check.
export const TOTAL_COUNTERS = 55;

// The two things a player can do on their turn (p2, Game Play 1a).
export const ACTION_TYPES = {
  TAKE_CARD: 'TAKE_CARD',
  DECLINE_CARD: 'DECLINE_CARD',
  // Not a player move: deals the next round of a multi-round match.
  NEXT_ROUND: 'NEXT_ROUND',
};

// Phases the game state can be in. `finished` is terminal; `roundOver` is
// the pause between rounds of a multi-round match, waiting for NEXT_ROUND.
export const PHASES = {
  PLAYING: 'playing',
  ROUND_OVER: 'roundOver',
  FINISHED: 'finished',
};

// HOUSE RULE, not the rulebook. The AMIGO rules describe a single game and
// say nothing about rounds (p3, Winning the Game). Matt asked for the way
// people actually play it (bug report, 2026-09-30): "you play several rounds
// and then have a total score across those rounds ... choose the number of
// rounds at the beginning of the game." One round is the default and is
// exactly the rulebook game.
export const MIN_ROUNDS = 1;
export const MAX_ROUNDS = 5;

export const clampRounds = (n) => Math.min(Math.max(Math.floor(Number(n)) || MIN_ROUNDS, MIN_ROUNDS), MAX_ROUNDS);
